import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-103" data-mp="2z2z18ykci74t">
      <div className="mx-auto max-w-3xl" data-id="element-104" data-mp="2z5bdcv3f9n9y">
        <h2 className="text-center font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-105" data-mp="3ms9t1qjpwr6t">Frequently Asked Questions</h2>

        <div className="mt-10 divide-y divide-slate-200 border-y border-slate-200" data-id="element-106" data-mp="3rrcyvd7iv1fu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-107" data-mp="3i11j8teh73t4" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-108" data-mp="3i004aduc9x64">
                  <span className="font-display text-[17px] font-extrabold leading-snug text-ink" data-id="element-109" data-mp="20ri48muve0gx">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-brand-deep" : "bg-navy"}`} data-id="element-110" data-mp="1vt6t88su9jx4">
                    <PlusIcon className="h-4 w-4 text-white" aria-hidden data-id="element-111" data-mp="25oi76owfan3t" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-112" data-mp="2ei53qh8gfue2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-113" data-mp="2ek7q8raef5e1">
                      <p className="pb-5 text-[15px] leading-relaxed text-slate-600" data-id="element-114" data-mp="u3bf4aocelwv">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-12" data-id="element-115" data-mp="1nu3jr1brp945">
          <CTAButton label="I’m ready — give me instant access" data-id="element-116" data-mp="1sqkh8m4uwztw" />
        </div>
      </div>
    </section>;
}